// chart-waarde-woning-schatten.js

import '/src/tailwind.css';

document.addEventListener('DOMContentLoaded', function () {
    window.addEventListener('scroll', loadChart, { once: true });

    function loadChart() {
        // Load Font Awesome CSS
        const fontAwesomeCSS = document.createElement('link');
        fontAwesomeCSS.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
        fontAwesomeCSS.rel = 'stylesheet';
        document.head.appendChild(fontAwesomeCSS);

        // Load Chart.js script
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/chart.js';
        script.onload = function () {
            const ctx = document.getElementById('epcPriceBarChart').getContext('2d');
            const epcPriceBarChart = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: ['Label A', 'Label B', 'Label C', 'Label D', 'Label E', 'Label F'],
                    datasets: [
                        {
                            label: '2021',
                            data: [315000, 288000, 285000, 275000, 251000, 229000],
                            backgroundColor: 'rgba(255, 159, 64, 0.6)',
                            borderColor: 'rgba(255, 159, 64, 1)',
                            borderWidth: 1
                        },
                        {
                            label: '2022',
                            data: [326161, 315000, 306050, 290000, 274000, 245000],
                            backgroundColor: 'rgba(255, 99, 132, 0.6)',
                            borderColor: 'rgba(255, 99, 132, 1)',
                            borderWidth: 1
                        },
                        {
                            label: '2023',
                            data: [350000, 320000, 315000, 300000, 265000, 246000],
                            backgroundColor: 'rgba(54, 162, 235, 0.6)',
                            borderColor: 'rgba(54, 162, 235, 1)',
                            borderWidth: 1
                        },
                        {
                            label: '2024',
                            data: [389450, 325000, 315500, 295000, 275000, 240640],
                            backgroundColor: 'rgba(75, 192, 192, 0.6)',
                            borderColor: 'rgba(75, 192, 192, 1)',
                            borderWidth: 1
                        }
                    ]
                },
                options: {
                    responsive: true, // Makes the chart responsive
                    maintainAspectRatio: false,  // Allows the chart to adapt to different screen sizes
                    title: {
                        display: true,
                        text: 'Gemiddelde Woningprijzen per Energielabel (2021-2024)',
                        fontSize: 18
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: false,
                                callback: function(value) {
                                    return '€' + value.toLocaleString(); // Format as currency
                                }
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Gemiddelde Woningprijs (€)'
                            }
                        }],
                        xAxes: [{
                            scaleLabel: {
                                display: true,
                                labelString: 'Energielabel'
                            }
                        }]
                    }
                }
            });
        };
        document.body.appendChild(script);
    }
});
